<template>
	<div class="p_b100 f_s14">
		<div class="mine_order_detail" v-if="Object.keys(orderinfo).length">
			<!-- 流程图复用： -->
			<div class="mine_order_son_box_body_bottom" v-if="formatProgress(orderinfo.orderType).length">
				<div class="mine_order_son_box_body_bottom_inner">
					<!-- some of one start: -->
					<div class="mine_order_son_box_body_bottom_inner_some_of_one"
						v-for="(item, index) in formatProgress(orderinfo.orderType)" :key="index">
						<div :class="[
								'circle',
								index < progressCount(progressCover(orderinfo.orderLogisticsStatus, orderinfo.orderType == 1), formatProgress(orderinfo.orderType)) ? 'off_the_stocks' : '',
								item === progressCover(orderinfo.orderLogisticsStatus, orderinfo.orderType == 1) ? 'active' : '',
							]"></div>
						<div
							:class="['line', index < progressCount(progressCover(orderinfo.orderLogisticsStatus, orderinfo.orderType == 1), formatProgress(orderinfo.orderType)) - 1 ? 'active' : '']">
							<div class="circle_bottom_text">{{ item }}</div>
						</div>
					</div>
					<!-- some of one end -->
				</div>
			</div>
			<!-- 详情： -->
			<div class="mine_order_detail_big_box">
				<div class="mine_order_detail_header">
					{{ $t('Mine.MineOrder.orderNumber') }}：{{ orderinfo.orderNo }}{{ orderinfo.takeMealNumber ? '#' +
					orderinfo.takeMealNumber : '' }}
					<a v-if="orderinfo.cabinet && orderinfo.cabinet.cabinetBtnName" @click="showCabinet(orderinfo)">{{
						orderinfo.cabinet.cabinetBtnName }}</a>
					<!-- 取餐号 -->
					<!-- <span v-if="[1,6,7].includes(orderinfo.orderStatus) && orderinfo.storeOrderId" style="float:right;">取餐号 {{ orderinfo.storeOrderId ? orderinfo.storeOrderId.split('#')[1] : ''}}</span> -->
					<span v-if="[1, 6, 7].includes(orderinfo.orderStatus) && orderinfo.storeOrderId"
						style="float:right;"><span v-if="sameDay">取餐号 {{ orderinfo.takeMealNumber ?
							orderinfo.takeMealNumber : '' }}</span></span>
				</div>
				<div class="mine_order_detail_body">
					<div class="mine_order_detail_body_info_by_goods">
						<div class="table_header">
							{{ $t('Mine.MineOrder.commodityInformation') }}
						</div>
						<div class="mine_order_detail_body_info_by_goods_body">
							<div class="content_box">
								<!-- some of one: -->
								<div class="content_box_inner" v-for="item in orderinfo.osProducts &&
										orderinfo.osProducts.filter((res) => {
											return res.productName !== '天猫';
										})" :key="JSON.stringify(item)">
									<div>
										<div>{{ item.productName }}</div>
										<div class="sizeAndName">{{ item.productSizeText }}{{ item.productPastryName &&
											item.productSizeText ? '、' + item.productPastryName : item.productPastryName
											}}, <span v-if="item.productText">
												、{{ item.productText.replace(/\,/g, ' 、') }}
											</span></div>
										<ul class="Order_lis" v-if="item.productType !== 2 && item.osProductDetails"
											style="overflow: hidden;">
											<li style="margin-left: 10px; float: left;"
												v-if="item.osProductDetails && item.osProductDetails.length !== 0 && extratopping(item.osProductDetails)">
												变动配料
											</li>
											<template v-for="(extra, k) in item.osProductDetails.filter((resii) => {
													return Math.abs(resii.quantity - resii.isDefault) > 0;
												})">
												<li style="margin-left: 10px; float: left;"
													v-if="extra.productType === 3" :key="k">
													{{
													lang == 'zh'
													? extra.propertyKey && extra.propertyKey.split('|') &&
													extra.propertyKey.split('|').length > 1
													? extra.propertyKey.split('|')[0]
													: extra.propertyKey
													: extra.propertyKey && extra.propertyKey.split('|') &&
													extra.propertyKey.split('|').length > 1
													? extra.propertyKey.split('|')[1]
													: extra.propertyKey
													}}
													{{ extra.quantity - extra.isDefault > 0 ? '+' + (extra.quantity -
													extra.isDefault) : '(去)' }}
													{{
													k + 1 ==
													item.osProductDetails.filter((resii) => {
													return resii.productType === 3 && Math.abs(resii.quantity -
													resii.isDefault) > 0;
													}).length
													? ''
													: '、'
													}}
												</li>
											</template>
										</ul>
									</div>
									<div>{{ item.quantity }}</div>
									<div>
										<span
											v-if="item.price && item.price != item.unitPrice * item.quantity && item.unitPrice"
											class="text-line">¥{{ (item.unitPrice * item.quantity) | formatMoney(2, '')
											}}</span>
										<span>¥{{ item.price || (item.unitPrice * item.quantity) | formatMoney(2, '')
											}}</span>
									</div>
								</div>
								<div v-if="orderinfo && orderinfo.coupons" class="boldpaddingLeft20">
									优惠券
								</div>
								<template v-if="orderinfo && orderinfo.coupons">
									<div class="colorss TMCouponBox" v-for="(TmCoupon, idex) in orderinfo.coupons"
										:key="idex">
										<div>
											<div class="TMMain content_box_inner">
												<div class="TMName">
													<div class="boldpaddingLeft20">
														{{ TmCoupon.couponName }}
													</div>
												</div>
												<div class="TMNumber">
													{{ !TmCoupon.osProducts ? TmCoupon.couponTotal : ' ' }}
												</div>
												<div class="TMPrice">
													<span class="tline"
														style="text-decoration: line-through; margin-right: 4px;">¥{{
														(TmCoupon.countPrice || 0) | formatMoney(2, '') }}</span>
													<span class="lightred">¥{{ (TmCoupon.countPricePe || 0) |
														formatMoney(2, '') }}</span>
												</div>
											</div>
											<template v-if="TmCoupon.osProducts">
												<div class="content_box_inner"
													v-for="(TmCouponProd, idx) in TmCoupon.osProducts" :key="idx">
													<div class="TMliName">
														<div style="padding-left:30px">
															{{ TmCouponProd.productName }}
														</div>
													</div>
													<div class="TMliCount">
														{{ TmCouponProd.quantity }}
													</div>
													<div class="TMliCount"></div>
												</div>
											</template>
										</div>
									</div>
								</template>
								<div v-if="orderinfo.osCoupons && orderinfo.osCoupons.length" class="free_coupon">
									<div class="title">
										{{ (lang == 'zh' ? orderinfo.osCoupons[0].couponName :
										orderinfo.osCoupons[0].couponNameEn) || $t('Mine.MineOrder.freeCoupon') }}
									</div>
									<div class="num">{{ orderinfo.osCoupons.length }}</div>
								</div>
							</div>
							<!-- mega提示 -->
							<div v-if="orderinfo.ruleMsgLists && orderinfo.ruleMsgLists.length"
								class="megacoupontiptype3">
								<span colspan="3">{{ orderinfo.ruleMsgLists[0] }}</span>
							</div>
							<div class="no_content_box">
								<div class="blue blue_text"></div>
								<div class="golden m_b10">
									{{ $t('Mine.MineOrder.usedOffer') }}
								</div>
								<div class="golden_bottom">{{ $t('Mine.MineOrder.thirdPartyOffers') }}：{{
									orderinfo.cashCouponAmount ? orderinfo.cashCouponAmount : '未使用第三方优惠' }}</div>
								<div class="mixture_money">
									<div style="flex: 1">
										<div v-if="orderinfo.activityAmount">
											{{ $t('Mine.MineOrder.discount') }}
											<span class="golden iconfont icon-shuoming1 cursor_pointer fontsize16"
												@click="lookDiscounts(orderinfo)"></span>
											：¥{{ orderinfo.activityAmount }}
										</div>
										<div>{{ $t('Mine.MineOrder.deliveryFee') }}：¥{{ (orderinfo.freightAmount || 0) |
											formatMoney(2, '') }}</div>
										<div
											v-if="orderinfo.banOfPlasticConfigDTO && orderinfo.banOfPlasticConfigDTO.plasticAmount">
											{{
											lang == 'zh'
											? orderinfo.banOfPlasticConfigDTO.itemNameCn + '(' +
											orderinfo.banOfPlasticConfigDTO.describeCn + ')'
											: orderinfo.banOfPlasticConfigDTO.itemNameEn + '(' +
											orderinfo.banOfPlasticConfigDTO.describeEn + ')'
											}}：¥{{ orderinfo.banOfPlasticConfigDTO.plasticAmount || 0 }}
										</div>
										<div>
											<span>{{ $t('Mine.MineOrder.paid') }}：¥{{ orderinfo.alreadyPayAmount |
												formatMoney(2, '') }}</span>
											<span style="margin-right: 5px"></span>
											<span v-if="orderinfo.wechatLoveFeastDesc" style="font-size: 5px">{{ '(' +
												orderinfo.wechatLoveFeastDesc + ')' }}</span>
										</div>
										<div>
											{{ $t('Mine.MineOrder.amountPayable') }}：¥{{
											(orderinfo.orderAmountAfterActivity != null ?
											orderinfo.orderAmountAfterActivity : orderinfo.orderAmount) | formatMoney(2,
											'') }}
										</div>
										<div v-if="orderinfo.thermosBagDTO">
											{{ orderinfo.thermosBagDTO.productNameZh }}：<span>￥{{
												orderinfo.thermosBagDTO.thermosBagAmount | formatMoney(2, '') }}</span>
										</div>
										<div v-if="orderinfo.aliAllDiscountsAmount">{{ $t('Mine.MineOrder.aliPayable')
											}}￥{{ orderinfo.aliAllDiscountsAmount }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mine_order_detail_body_info_by_distribution">
						<div class="table_header">
							{{ $t('Mine.MineOrder.distributionInformation') }}
						</div>
						<div class="mine_order_detail_body_info_by_distribution_body">
							<div class="content_box">
								<div class="p_l15">
									<span>{{ $t('Mine.MineOrder.distributionMode') }}：</span>
									<span>{{ orderinfo.orderType === 1 ? '外带' : orderinfo.orderType === 0 ? '外送' :
										orderinfo.orderType === 2 ? '堂食' : '未知' }}</span>
								</div>
								<div>
									<span>{{ $t('Mine.MineOrder.shippingAddress') }}：</span>
									<span>{{
										orderinfo.orderType === 1 || orderinfo.orderType === 2
										? '--'
										: orderinfo.receiveAddress === orderinfo.deliverAddress
										? orderinfo.receiveAddress
										: (orderinfo.receiveAddress == undefined ? '' : orderinfo.receiveAddress) +
										(orderinfo.deliverAddress == undefined ? '' : orderinfo.deliverAddress)
										}}</span>
								</div>
								<div>
									<span>{{ $t('Mine.MineOrder.remarks') }}：</span>
									<span>{{ orderinfo.remark }}</span>
								</div>
								<div class="p_l15">
									<span>{{ $t('Mine.MineOrder.deliveryStore') }}：</span>
									<span>{{ orderinfo.storeName }}</span>
								</div>
								<div>
									<span>{{ $t('Mine.MineOrder.storePhone') }}：</span>
									<span>{{ linkPhone }}</span>
								</div>
								<div>
									<span>{{ $t('Mine.MineOrder.diner') }}：</span>
									<span>{{ orderinfo.receiverName }} {{ orderinfo.receiverMobile }}</span>
								</div>
								<div class="p_l15" v-if="orderinfo.noPlanTime != 1">
									<span>{{ orderinfo.orderType === 0 ? $t('Mine.MineOrder.expectedDeliveryTime') :
										$t('Mine.MineOrder.selfTime') }}</span>
									<span>{{ orderinfo.plannedDeliverTime }}</span>
									<span
										v-if="((orderinfo.planTimeTxt || (orderinfo.planTimeTxt && orderinfo.planTimeTxt.length != 0)) && orderinfo.orderType === 1)"
										style="font-size: 12px; margin-left: 5px; color: #666666">{{
										orderinfo.planTimeTxt }}</span>
								</div>
								<div :class="{ isDistance: orderinfo.noPlanTime == 1 }">
									<span>{{ $t('Mine.MineOrder.invoice') }}：</span>
									<span>{{ orderinfo.invoiceTitle ? orderinfo.invoiceTitle : '- -' }}</span>
								</div>
							</div>
							<div class="no_content_box"></div>
						</div>
					</div>
					<div class="mine_order_detail_body_info_by_pay">
						<div class="table_header">
							{{ $t('Mine.MineOrder.paymentMethod') }}
						</div>
						<div class="mine_order_detail_body_info_by_pay_body">
							<div>
								<span>{{ $t('Mine.MineOrder.paymentMethod') }}：</span>
								<span>{{ orderinfo.paySource | paySourceFormatter }}</span>
							</div>
							<!-- 货到付款时候不显示 -->
							<!-- 支付狀態： -->
							<div v-show="orderinfo.paySource != 4">
								<span>{{ $t('Mine.MineOrder.paymentStatus') }}：</span>
								<span>{{ orderinfo.orderStatus | orderStatusFormatter }}</span>
							</div>
							<!-- 订单状态： -->
							<!-- <div v-if="!(orderinfo.orderStatus == 8 && orderinfo.orderType != 0)"> -->
							<div>
								<span>{{ $t('Mine.MineOrder.orderStatus') }}：</span>
								<span>{{ stateInfo.name }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="btn-comment-box">
				<span class="go_detail02"
					v-if="commentFlag == 1 && pageType == 2 && orderinfo.displayDeleteOrderButton == 1"
					@click="deleteOrder(orderinfo)"> {{ $t('Mine.MineOrder.deleteOrder') }} </span>

				<span class="go_detail02" v-if="commentFlag == 1 && pageType == 2"
					@click="onHandleComment(orderinfo)">{{orderinfo.switchFlag ? orderinfo.commentButtonNameCN :
					$t('Mine.MineOrder.btnComment')}}</span>
				<button class="go_detail02_disable" v-if="commentFlag == 2 && pageType == 2" @click="onHandle01">
					{{ $t('Mine.MineOrder.btnCommentFinished') }}
				</button>
				<button class="go_detail02_disable" v-if="commentFlag == 3 && pageType == 2" @click="onHandle02">
					{{ $t('Mine.MineOrder.btnComment') }}
				</button>
				<!--     invoiceStatus = 4: 微信爱心餐   -->
				<span class="go_detail02" @click="onHandleInvoice(orderinfo)"
					v-if="commentFlag == 1 && pageType == 2 && orderinfo.invoiceStatus != 4">
					<span v-if="orderinfo.orderStatus === 8 && orderinfo.invoiceStatus == 1">{{
						$t('Mine.toMakeOutAnInvoice') }}</span>
					<span v-if="orderinfo.orderStatus === 8 && orderinfo.invoiceStatus == 2">{{ $t('Mine.isInvoicing')
						}}</span>
					<span v-if="orderinfo.orderStatus === 8 && orderinfo.invoiceStatus == 3">{{ $t('Mine.isInvoiced')
						}}</span>
				</span>
			</div>
		</div>
		<!-- 弹框： -->
		<myself-dialog :dialogFlag="DiscountsBoxFlag" @hideMask="hideMask" width="350px" :hasBorder="false">
			<div class="box_about_explain_inner">
				<div class="header">
					<span class="iconfont icon-tishi"></span>
					<span>{{ $t('Mine.MineOrder.discount') }}</span>
				</div>
				<div class="body" v-html="DiscountsBoxInner"></div>
				<div class="footer">
					<span @click="hideMask">确定</span>
				</div>
			</div>
		</myself-dialog>
		<!-- 取餐柜信息 -->
		<van-dialog v-model="cabinetShow" :title="$t('Mine.MineOrder.confirmPickOut')" confirmButtonText="知道了"
			:closeOnClickOverlay="false" className="cabinet-dialog">
			<div class="cabinet-dialog-content" v-if="cabinetInfo">
				<p>{{ $t('Mine.MineOrder.remindContent') }}</p>
				<div class="cabinet-content">
					<ul class="info-content">
						<li>{{ $t('Mine.MineOrder.containerNumber') }}：{{ cabinetInfo.cabinetNumber }}</li>
						<li>{{ $t('Mine.MineOrder.PickUpCode') }}：{{ cabinetInfo.cabinetCode }}</li>
					</ul>
					<div class="qrcode-content">
						<div ref="qrcode"></div>
					</div>
				</div>
			</div>
		</van-dialog>
	</div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import orderStore from '@store/order/order.store';
import * as formatMoney from '@extend/filters/app/formatMoney';
import Md5 from 'md5';
import $urlTools from '@/utils/url';
import orderStateFilter from '@extend/filters/app/orderState';

// 二维码插件
import QRCode from 'qrcodejs2';
export default {
	components: {
		'myself-dialog': () => import('@/components/modal/myselfdialog/myselfdialog.vue'),
	},
	data() {
		return {
			getDetailId: '',
			commentFlag: null, //是否已经评论
			pageName: '',
			sameDay: null,
			orderinfo: {}, //订单详情
			stateInfo: {}, // 状态信息
			progressList: ['接单', '制作', '进炉', '质检', '派送', '完成'],
			DiscountsBoxFlag: false,
			DiscountsBoxInner: '',
			//是否是老数据
			oldData: false,
			//超值兑换的金额
			recommPrice: 0,
			individualizationPriceAll: 0,
			//活动优惠
			Activitieslist: '',
			cabinetShow: false, // 取餐柜弹窗
			cabinetInfo: null, // 取餐柜信息
			QRCodeElement: null, // 二维码信息
			linkPhone: '', //门店电话
		};
	},
	filters: {
		// 支付状态：
		orderStatusFormatter: function(value) {
			let result = '- -';
			switch (value) {
				case 0:
					result = '未确认';
					break;
				case 1:
					result = '已接受';
					break;
				case 2:
					result = '已拒绝';
					break;
				case 3:
					result = '已取消';
					break;
				case 4:
					result = '支付失败';
					break;
				case 5:
					result = '待支付';
					break;
				case 6:
					result = '已支付';
					break;
				case 7:
					result = '货到付款';
					break;
				case 8:
					result = '已完成';
					break;
				case 9:
					result = '已退款';
					break;
				case 10:
					result = '未支付订单过期取消';
					break;
				case 11:
					result = '已取消';
					break;
			}
			return result;
		},
		// 支付方式：
		paySourceFormatter: function(value) {
			switch (value) {
				// 1.支付宝；2.微信 ；3.银联；4.货到付款;6礼品卡;7礼品卡+微信支付;8 礼品卡+支付宝;9 礼品卡+银联;
				case 1:
					return '支付宝';
				case 2:
					return '微信';
				case 3:
					return '银联';
				case 4:
					return '货到付款';
				case 6:
					return '达美乐电子预付卡';
				case 7:
					return '达美乐电子预付卡+微信支付';
				case 8:
					return '达美乐电子预付卡+支付宝';
				case 9:
					return '达美乐电子预付卡+银联';
				case 10:
					return '线上支付';
				case 11:
					return '货到付款';
				case 14:
					return '达美乐电子礼品卡';
				case 15:
					return '达美乐电子礼品卡+微信支付';
				case 16:
					return '达美乐电子礼品卡+支付宝';
				case 17:
					return '达美乐电子礼品卡+银联';
				case 18:
					return '达美乐电子预付卡+达美乐电子礼品卡';
				case 19:
					return '达美乐电子预付卡+达美乐电子礼品卡+微信支付';
				case 20:
					return '达美乐电子预付卡+达美乐电子礼品卡+支付宝';
				case 21:
					return '达美乐电子预付卡+达美乐电子礼品卡+银联';
				case 23:
					return '抖音支付';
				case 27:
					return '龙支付';
				case 28:
					return '达美乐电子礼品卡+龙支付';
				case 29:
					return '达美乐电子预付卡+龙支付';
				case 30:
					return '达美乐电子预付卡+达美乐电子礼品卡+龙支付';
				case 31:
				return '预付卡和抖音支付';
				case 32:
				return '礼品卡和抖音支付';
				case 33:
				return '预付卡礼品卡和抖音支付';

				default:
					return '';
			}
		},
	},
	methods: {
		async getDetail() {
			try {
				this.$dominosloading.show();
				let params = {
					orderId: this.getDetailId,
				};
				this.pageName == 'history' && (params.pageName = this.pageName);
				let { data: result } = await this.$get('queryOrderInfo', params);
				let { data: storeInfo } = await this.$get('getStoreInfoByStoreCode', { storeCode: result.data.storeCode });
				this.linkPhone = storeInfo.data.storeTel ? storeInfo.data.storeTel : storeInfo.data.standbyTel ? storeInfo.data.standbyTel : '4001-597-597';
				this.$dominosloading.hide();
				if (result.errCode != '00') return Toast(result.errMsg);
                // result.data.planTimeTxt = '' // '以系统推送取餐通知为准'
				this.orderinfo = result.data;
				console.log('this.orderinfo = result.data;', result.data.thermosBagDTO);
				this.commentFlag = this.orderinfo.commentFlag;

				// 取餐柜信息
				if (this.orderinfo.cabinet) {
					this.orderinfo.cabinet.cabinetBtnName = {
						1: this.$t('Mine.MineOrder.checkCode'),
						2: this.$t('Mine.MineOrder.takenOut'),
					}[this.orderinfo.cabinet.cabinetComplete];
				}
				if (this.orderinfo.plannedDeliverTime) {
					this.sameDay = new Date().toLocaleDateString() == new Date(this.orderinfo.plannedDeliverTime.replace(/-/g, '/')).toLocaleDateString();
				} else {
					this.sameDay = false;
				}

				this.orderinfo.osProducts.push({
					productName: '配送费',
					quantity: 1,
					price: this.orderinfo.freightAmount,
				});
				this.orderStateTransform(this.orderinfo.orderStatus);

				// 神策埋点
				this.sensorsTrack();
			} catch (err) {
				console.log(err);
			}
		},
		//变动配料
		extratopping(v) {
			let flag = false;
			if (v) {
				let newv = v.filter((item) => {
					return Math.abs(item.quantity - item.isDefault) > 0 && item.productType != 4;
				});
				flag = newv.length > 0;
				return flag;
			}
			return flag;
		},
		orderStateTransform(orderStatus) {
			switch (Number(orderStatus)) {
				// 已取消
				case 2:
					this.innerState = 5;
					this.stateInfo = {
						name: '已取消',
						class: 'err',
						message: '商家拒接',
						icon: 'dm-shibaibaocuo',
					};
					break;
				case 3:
					this.innerState = 5;
					this.stateInfo = {
						name: '已取消',
						class: 'err',
						message: '商家取消',
						icon: 'dm-shibaibaocuo',
					};
					break;
				// 支付失败
				case 4:
					this.innerState = 4;
					this.stateInfo = {
						name: '已取消',
						class: 'err',
						message: '支付失败',
						icon: 'dm-shibaibaocuo',
					};
					break;
				// 已退款
				case 9:
					this.innerState = 4;
					this.stateInfo = {
						name: '已取消',
						class: 'err',
						message: '已退款',
						icon: 'dm-shibaibaocuo',
					};
					break;
				// 未支付订单过期取消
				case 10:
					this.innerState = 4;
					this.stateInfo = {
						name: '已取消',
						class: 'err',
						message: '未支付订单过期',
						icon: 'dm-shibaibaocuo',
					};
					break;
				// 待付款
				case 5:
					this.innerState = 1;
					this.stateInfo = {
						name: '等待付款',
						class: 'wait',
						message: '付款截止时间',
						icon: 'dm-shijian',
					};
					break;
				// 已完成
				case 8:
					this.innerState = 3;
					this.stateInfo = {
						name: '已完成',
						class: 'success',
						message: '感谢您选择达美乐,期待再次光临',
						icon: 'dm-wancheng',
					};
					break;
				case 11:
					this.innerState = 5;
					this.stateInfo = {
						name: '已取消',
						class: 'err',
						message: '订单已取消(人工)',
						icon: 'dm-shibaibaocuo',
					};
					break;
				// 待收餐
				case 1:
				case 6:
				case 7:
					this.innerState = 2;
					this.stateInfo = {
						name: orderStore.progressCover(this.orderinfo.statusInStore, this.orderinfo.orderType == 1, !0, this.orderinfo),
						class: 'soon',
						message: '外送30分钟必达,超时赠送免费比萨券',
						icon: 'dm-dengdai',
					};
					break;
				case 0:
					this.innerState = 2;
					this.stateInfo = {
						name: '未确认',
						class: 'soon',
						message: '外送30分钟必达,超时赠送免费比萨券',
						icon: 'dm-dengdai',
					};
			}
		},
		formatProgress(orderType) {
			// 根据订单类型返回相应流程数组：
			if (orderType === 0) {
				return this.progressList;
			} else {
				const askprogressList = this.progressList.concat();
				askprogressList[4] = '外带';
				return askprogressList;
			}
		},
		//删除订单
		deleteOrder(val) {
			// this.$toast({
			//   type: 'text',
			//   message: `删除订单`,
			//   duration: 2000,
			// });
			Dialog.alert({
				title: '亲，是否确认删除订单?',
				message: '删除的订单不可恢复，也无法申请开票和参与单单抽活动哦~',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				messageAlign: 'left',
			})
				.then(() => {
					// console.log('--确定--')
					this.deletePostOrder(val);
				})
				.catch(() => {
					// console.log('--取消--')
				});
		},
		async deletePostOrder(val) {
			let params = {
				orderId: this.getDetailId,
				orderNo: this.orderinfo.orderNo,
			};
			this.pageName == 'history' && (params.pageName = this.pageName);
			// console.log('--删除订单-val-', val)
			// return
			try {
				let { data: result } = await this.$post('deleteOrder', params);
				// console.log('--删除订单--', result)
				this.$toast({
					type: 'text',
					message: result.errMsg,
					duration: 2000,
				});
				if (result.errCode == '00') {
					// 刷新页面
					// this.getDetail();
					this.$router.push({ name: 'mineorderlist' });
				}
			} catch (err) {
				this.$toast({
					type: 'text',
					message: err.errMsg,
					duration: 2000,
				});
				console.log(err);
			}
		},

		//去评价
		onHandleComment(val) {
			let params = {
				id: val.id,
                orderType: val.orderType
			};
			this.$router.push({ name: 'commentdetail', params: params });
			this.sensorsTrack('去评价');
		},
		onHandle01() {
			return Toast('已评价');
		},
		onHandle02() {
			return Toast('该订单超过评价时间了哦');
		},
		// 订单轨迹状态转换成文字
		progressCover(code, ask, state) {
			let status = null;
			switch (code) {
				case 0:
					status = '待接单';
					break;
				case 1:
					status = '接单';
					break;
				case 2:
					status = '拒接';
					break;
				case 3:
					status = '取消';
					break;
				case 4:
				case 10:
					status = '制作';
					break;
				case 20:
					status = '进炉';
					break;
				case 30:
					status = '质检';
					break;
				case 40:
					status = ask ? '外带' : '派送';
					break;
				case 50:
					status = ask ? '完成' : '完成';
					break;
				case 99:
				default:
			}
			if (!state) return status || '未知';
			if (ask && code == 30) {
				status = '待外带';
			} else if (ask && code == 40) {
				status = '待' + status;
			} else if (code == 1) {
				status = '已' + status;
			} else if (code == 20) {
				status = '烘焙中';
			} else if (status) {
				status += '中';
			} else {
				status = '未知';
			}
			return status;
		},
		// 小于这个数字，应该高亮：
		progressCount(who, list) {
			let index = list.findIndex((item) => who === item);
			return index + 1;
		},
		// 查看优惠：
		lookDiscounts(orderinfo) {
			this.DiscountsBoxFlag = true;
			let CouponMoney = '',
				PointMoney = '',
				cashCouponAmount = '',
				couponDeliveryFeeMoney = '',
				tmallCouponMoney = '',
				dpDisAmount = '',
				aggMoney = '',
				// 推荐价格
				recommPrice = '',
				//联联券
				llCouponCountAmount = '',
				//建行券
				ccbCouponCountAmount = '',
				//支付宝券
				alipayCouponCountAmount = '',
				//支付宝团购券
				alipayGroupCouponCountAmount = '',
				//口碑券
				koubeiCouponCountAmount = '',
				//快手券
				ksCouponCountAmount = '',
				//京东券
				jdCouponCountAmount = '',
				//山姆券
				smCouponCountAmount = '',
				// 超值搭配（个性化营销活动优惠价格）
				IndividualizationPriceAll = '',
				yiBaiCouponAmount = '';
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[23]) {
				koubeiCouponCountAmount = "<p>口碑券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[23], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[38]) {
				smCouponCountAmount = "<p>山姆券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[38], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[22]) {
				alipayCouponCountAmount = "<p>支付宝券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[22], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[35]) {
				alipayGroupCouponCountAmount = "<p>支付宝团购券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[35], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[21]) {
				llCouponCountAmount = "<p>联联券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[21], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.dpDisAmount) {
				dpDisAmount = "<p>团购券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.dpCouponAmount, 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[34]) {
				ccbCouponCountAmount = "<p>建行券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[34], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[36]) {
				ksCouponCountAmount = "<p>快手券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[36], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.orderCouponBuyAmountMap && orderinfo.orderCouponBuyAmountMap[37]) {
				jdCouponCountAmount = "<p>京东券: <span style='float:right; color: #D30008;'>¥" + formatMoney.default.fn(orderinfo.orderCouponBuyAmountMap[37], 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.couponActivityAmount) {
				CouponMoney = '<p>优惠券: <span style="float:right; color: #D30008;">¥' + formatMoney.default.fn(orderinfo.couponActivityAmount, 2, '') + '</span></p>';
			}

			if (orderinfo && orderinfo.tmallCouponDiscountsAmount) {
				tmallCouponMoney = '<p>天猫券: <span style="float:right; color: #D30008;">¥' + formatMoney.default.fn(orderinfo.tmallCouponDiscountsAmount, 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.couponDeliveryFee) {
				couponDeliveryFeeMoney = '<p>券免运费: <span style="float:right; color: #D30008;">¥' + formatMoney.default.fn(orderinfo.couponDeliveryFee, 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.pointDeductionMoney) {
				PointMoney = '<p>积分抵扣:<span style="float:right; color: #D30008;"> ¥' + formatMoney.default.fn(orderinfo.pointDeductionMoney, 2, '') + '</span></p>';
			}
			if (this.individualizationPriceAll) {
				IndividualizationPriceAll = '<p>超值搭配: <span style="float:right; color: #D30008;">¥' + formatMoney.default.fn(this.individualizationPriceAll, 2, '') + '</span></p>';
			}
			if (this.recommPrice) {
				recommPrice = '<p>超值换购:<span style="float:right; color: #D30008;"> ¥' + formatMoney.default.fn(this.recommPrice, 2, '') + '</span></p>';
			}

			if (orderinfo && orderinfo.activityAmount) {
				aggMoney = '<p>总优惠:<span style="float:right; color: #D30008;"> ¥' + formatMoney.default.fn(orderinfo.activityAmount, 2, '') + '</span></p>';
			}
			if (orderinfo && orderinfo.yiBaiCouponAmount) {
				yiBaiCouponAmount = '<p>第三方产品券:<span style="float:right; color: #D30008;"> ¥' + formatMoney.default.fn(orderinfo.yiBaiCouponAmount, 2, '') + '</span></p>';
			}
			let osCategoryActivitieslist =
				CouponMoney +
				yiBaiCouponAmount +
				tmallCouponMoney +
				couponDeliveryFeeMoney +
				PointMoney +
				this.Activitieslist +
				recommPrice +
				koubeiCouponCountAmount +
				ksCouponCountAmount +
				jdCouponCountAmount +
				alipayCouponCountAmount +
				smCouponCountAmount +
				alipayGroupCouponCountAmount +
				llCouponCountAmount +
				ccbCouponCountAmount +
				dpDisAmount +
				IndividualizationPriceAll +
				aggMoney;
			if (this.oldData) {
				osCategoryActivitieslist = aggMoney;
			}
			this.DiscountsBoxInner = osCategoryActivitieslist;
		},
		//活动优惠
		async getActivePro() {
			try {
				let res = await this.$get(`order/orders/CouponMoney/${this.getDetailId}`);
				if (res.data.errCode !== '00') return Toast(res.data.errMsg);
				this.oldData = res.data.data.deficiencyMoneyFlag == 'Y' ? true : false;
				//超值兑换的金额
				if (res.data && res.data.data) {
					this.recommPrice = res.data.data.recommPrice || 0;
					this.individualizationPriceAll = res.data.data.individualizationPriceAll || 0;
				}
				res = res.data.data.list || [];
				let result = res.filter((item, i) => {
					return item.type !== 4;
				});
				if (result && result.length > 0) {
					let newResult = this.PreferentialAdd(result);
					let arr = newResult.map((item) => {
						return '<p>' + item.ruleName + " <span style='float:right; color: #D30008;'>¥" + item.priceBreaks.toFixed(2) + '</span></p>';
					});
					let ActivityTotalMoney = 0;
					newResult.map((item) => (ActivityTotalMoney = (ActivityTotalMoney * 100 + item.priceBreaks * 100) / 100));
					this.Activitieslist = "<p>活动优惠: <span style='float:right; color: #D30008;'>¥" + ActivityTotalMoney.toFixed(2) + '</span></p>' + arr.join('');
				}
			} catch (err) {
				console.log(err);
			}
		},
		//优惠说明里面的单品优惠相同ruleid的价格相加
		PreferentialAdd(result) {
			try {
				var tempArr = [];
				var arry = result;
				var temp = {};
				for (var i in arry) {
					var key = arry[i].ruleId;
					if (temp[key]) {
						temp[key].ruleId = temp[key].ruleId;
						temp[key].ruleName = temp[key].ruleName;
						temp[key].priceBreaks = temp[key].priceBreaks + arry[i].priceBreaks;
					} else {
						temp[key] = {};
						temp[key].ruleId = arry[i].ruleId;
						temp[key].ruleName = arry[i].ruleName;
						temp[key].priceBreaks = arry[i].priceBreaks;
					}
					temp[key].type = arry[i].type;
				}
				for (var k in temp) {
					tempArr.push(temp[k]);
				}
				return tempArr;
			} catch (err) {
				return result;
			}
		},
		hideMask() {
			this.DiscountsBoxFlag = false;
		},
		// 显示取餐柜信息
		showCabinet({ cabinet }) {
			if (!cabinet || cabinet.cabinetComplete != 1) {
				Dialog.alert({
					message: '亲，您的餐品已取出，感谢惠顾，祝您用餐愉快！',
					confirmButtonText: '知道了',
				}).then(() => {
					// on close
				});
			} else {
				this.cabinetShow = true;
				this.cabinetInfo = cabinet;
				this.$nextTick(() => {
					if (this.QRCodeElement) {
						this.QRCodeElement.clear();
					} else {
						this.QRCodeElement = new QRCode(this.$refs.qrcode, {
							text: cabinet.cabinetUrl,
							width: 88,
							height: 88,
							colorDark: '#000000',
							colorLight: '#ffffff',
							correctLevel: QRCode.CorrectLevel.H,
						});
					}
				});
			}
		},
		//点进进去电子发票
		onHandleInvoice(item) {
			let url = 'invoice://login/dominos';
			let tarUrl = url.split('//')[1];
			let sendData = {
				store_code: item.storeCode,
				order_no: item.orderNo,
				store_order_id: item.storeOrderId,
				from: 'order_list',
			};
			if (item.invoiceDetail == true) {
				this.toInvoice(tarUrl, sendData);
			}
			this.sensorsTrack('开发票');
		},
		// 获取跳转需要携带的token
		async toInvoice(url, sendData) {
			let ininParams = {
				systemCode: 'EI',
				authorizeType: '',
			};
			try {
				let { data: result } = await this.$post('getTokenToThird', ininParams);
				if (result.errCode !== '00') return Toast(result.errMsg);
				let token = result.data.token;
				if (token) {
					let params = {
						req_data: '',
						system_code: 'EI',
						authorize_type: '',
						domino_token: token,
						timestamp: new Date().getTime(),
						channel_id: 2,
						channel_code: 'WEB',
						store_code: localStorage.getItem('ewalletStorecode') || '1233212',
						...sendData,
					};
					// 目标站点
					const tagegetUrl = $urlTools.computedUrl(`${this.invoiceHost}/${url}`, {
						...params,
						sign: this.createSign(params, this.invoiceSecretKey),
					});
					window.location.href = tagegetUrl;
				}
			} catch (err) {
				console.log(err);
			}
		},
		/**
		 * 生成参数签名
		 * @param sendData 发送的数据
		 * @param secretKey 密钥
		 * @returns {*}
		 */
		createSign(sendData, secretKey = '') {
			return Md5(
				[secretKey]
					.concat(Object.values(sendData))
					.sort((a, b) => {
						let A = String(a || '').trim();
						let B = String(b || '').trim();
						return A > B ? 1 : A < B ? -1 : 0;
					})
					.join('')
			).toUpperCase();
		},
		// 神策埋点
		sensorsTrack(operate_type) {
			let detailed = this.orderinfo;
			// 埋点数据
			let tractData = {
				order_id: detailed.id,
				order_type: '',
				order_status: orderStateFilter.fn(detailed.orderStatus),
				has_commented: detailed.commentFlag == 2,
				has_invoiced: detailed.invoiceStatus == 3,
				has_raffle: detailed.luckyMaxTimes > 0 ? !detailed.luckyCurrentTimes : false,
			};
			// 操作类型
			if (operate_type) tractData.operate_type = operate_type;
			// 神策埋点
			// this.$Sensors.track(operate_type ? "MyOrderDetailOperate" : "MyOrderDetailView", tractData)
		},
	},
	created() {
		this.getDetailId = this.$route.params.id;
		this.pageName = this.$route.params.pageName;
		if (!this.getDetailId) return this.$router.push({ name: 'mine' });
		this.getDetail();
		this.getActivePro();
	},
	computed: {
		//获取当前语言
		lang() {
			return this.$i18n.locale;
		},
		//获取订单类型
		pageType() {
			return this.$route.params.pageType; // 0:代付款 1:待收/取餐 2:历史订单
		},
		invoiceHost() {
			let mobileHref = '';
			let locationHref = location.href;
			if (locationHref.includes('https://web8-fun.dominos.com.cn/')) {
				mobileHref = 'https://e-invoice-member-fun.dominos.com.cn';
			} else if (locationHref.includes('https://www.dominos.com.cn/')) {
				mobileHref = 'https://e-invoice-member.dominos.com.cn';
			} else {
				mobileHref = 'https://e-invoice-member-fun.dominos.com.c';
			}
			return mobileHref;
		},
		invoiceSecretKey() {
			let curKey = '';
			let locationHref = location.href;
			if (locationHref.includes('https://web8-fun.dominos.com.cn/')) {
				curKey = 'e480cd50e4a7dcefbe3501bd2df1b4f3';
			} else if (locationHref.includes('https://www.dominos.com.cn/')) {
				curKey = '6dc61a9072bb27763f9913dd3403344a';
			} else {
				curKey = 'https://e-invoice-member-fun.dominos.com.c';
			}
			return curKey;
		},
	},
};
</script>

<style lang="scss" scoped>
.mine_order_detail {
	margin-left: 100px;
	margin-right: 100px;
	.mine_order_son_box_body_bottom {
		// background-color: green;
		display: none;
		padding: 50px 0;
		.mine_order_son_box_body_bottom_inner {
			width: 85%;
			height: 50px;
			// background-color: red;
			// margin: 0 auto;
			margin-left: 100px;
			display: flex;
			.mine_order_son_box_body_bottom_inner_some_of_one {
				flex: 1;
				height: 15px;
				display: flex;
				align-items: center;
				.circle {
					width: 10px;
					height: 10px;
					border-radius: 50%;
					background-color: #bfbfbf;
					&.off_the_stocks {
						background-color: #fc3231;
					}
					&.active {
						animation: progressline 0.6s linear infinite alternate;
						background-color: #fc3231;
						position: relative;
						&::before {
							width: 15px;
							height: 15px;
							border: 1px solid #fc3231;
							content: '';
							border-radius: 50%;
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
				.line {
					flex: 1;
					height: 2px;
					background-color: #e8e8e8;
					position: relative;
					&.active {
						background-color: #fc3231;
					}
					.circle_bottom_text {
						position: absolute;
						bottom: -30px;
						left: -20px;
					}
				}
				&:last-child {
					.line {
						// opacity: 0;
						background-color: transparent;
					}
				}
			}
		}
	}
	.mine_order_detail_big_box {
		width: 100%;
		min-height: 200px;
		// background-color: green;
		// margin-bottom: 100px;
		.mine_order_detail_header {
			text-align: left;
			padding: 0 15px;
			height: 40px;
			line-height: 40px;
			box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
			font-weight: bold;
		}
		.mine_order_detail_body {
			text-align: left;
			box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4);
			.mine_order_detail_body_info_by_goods {
				.mine_order_detail_body_info_by_goods_body {
					display: flex;
					flex-direction: column;
					.content_box {
						flex: 1;
						display: flex;
						flex-direction: column;
						.content_box_inner {
							display: flex;
							min-height: 40px;
							align-items: center;
							div {
								&:nth-of-type(1) {
									flex: 1;
									padding-left: 15px;
								}
								&:nth-last-of-type(-n + 2) {
									flex: 1;
								}
								.sizeAndName {
									padding-left: 15px;
									color: #828282;
									font-size: 12px;
								}
								.text-line {
									color: #757575;
									text-decoration: line-through;
									padding-right: 10px;
								}
							}
						}
					}
					.no_content_box {
						flex: 1;
						padding-left: 15px;
						.blue_text {
						}
						.golden_bottom {
						}
						.mixture_money {
							padding: 20px 0;
							display: flex;
							flex-direction: row;
						}
					}
				}
			}
			.mine_order_detail_body_info_by_distribution {
				.mine_order_detail_body_info_by_distribution_body {
					display: flex;
					.content_box {
						flex: 3;
						display: flex;
						flex-wrap: wrap;
						div {
							width: 33.33%;
							padding-top: 10px;
							padding-bottom: 10px;
							padding-right: 15px;
							text-align: left;
							span {
								&:nth-of-type(1) {
									color: #000;
								}
								&:nth-of-type(2) {
									color: #666;
								}
							}
						}
					}
				}
			}
			.mine_order_detail_body_info_by_pay {
				.mine_order_detail_body_info_by_pay_body {
					div {
						height: 40px;
						line-height: 40px;
						padding-left: 15px;
					}
				}
			}
		}
	}
}

@keyframes progressline {
	from {
		opacity: 0;
		transform: scale(0);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

.table_header {
	height: 40px;
	line-height: 40px;
	background-color: #fafafa;
	text-align: left;
	padding-left: 15px;
	font-weight: bold;
	border-top: 2px solid #ededed;
	border-bottom: 2px solid #ededed;
}
.golden {
	color: #ffc260;
}
.blue {
	color: #4d96c0;
}
.address_box {
	display: flex;
	span {
		&:nth-of-type(2) {
			flex: 1;
		}
	}
}

.box_about_explain_inner {
	text-align: left;
	.header {
		font-weight: bold;
		height: 40px;
		display: flex;
		align-items: center;
		position: relative;
		&::before {
			content: '';
			width: calc(100% + 40px);
			height: 100%;
			background-color: #f7f7f7;
			position: absolute;
			top: 0;
			left: -20px;
			z-index: -1;
			border-radius: 10px 10px 0 0;
		}
		.iconfont {
			color: #fbd9a5;
			font-weight: bold;
			font-size: 20px;
			margin-right: 10px;
		}
	}
	.body {
		padding: 15px 0;
		font-size: 14px;
	}
	.footer {
		height: 70px;
		display: flex;
		justify-content: center;
		span {
			display: block;
			height: 40px;
			width: 100px;
			background-color: $theme_red;
			box-shadow: 0 0 5px $theme_red;
			line-height: 40px;
			text-align: center;
			border-radius: 5px;
			color: #fff;
			cursor: pointer;
			&:hover {
				background-color: rgb(155, 4, 9);
			}
		}
	}
}
.megacoupontiptype3 {
	font-size: 12px;
	width: 98%;
	margin: 0 auto;
	text-align: left;
	color: #006aa6;
	padding-bottom: 20px;
}
.Order_lis {
	color: #ffc260;
	margin-left: 6px;
	font-size: 12px;
}
.TMUl {
	display: flex;
	.TMliName {
		flex: 1;
	}
	.TMliCount {
		flex: 1;
	}
}
.boldpaddingLeft20 {
	font-weight: 700;
	padding-left: 16px;
}
.free_coupon {
	display: flex;
	padding-left: 16px;
	.title {
		width: 33.33%;
	}
	.num {
		flex: 1;
	}
}
// 取餐柜
.cabinet-dialog {
	/deep/ .van-dialog__header {
		font-weight: 700;
	}
}
.cabinet-dialog-content {
	width: 100%;

	> h5 {
		font-size: 16px;
		font-weight: bold;
	}

	> h5,
	> p {
		width: 100%;
		text-align: center;
	}
}

.cabinet-content {
	padding: 20px;
	display: flex;

	.info-content {
		width: 55%;
		display: inline-block;

		li {
			line-height: 30px;
		}
	}

	.qrcode-content {
		width: 40%;
		display: inline-block;
		overflow: hidden;
	}
}
.btn-comment-box {
	display: flex;
	justify-content: center;
	padding-top: 15px;
	.go_detail02 {
		width: 110px;
		height: 35px;
		display: inline-block;
		border-radius: 5px;
		margin-right: 20px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #d30008;
		border: 2px solid #d30008;
	}
	.go_detail02_disable {
		width: 110px;
		height: 35px;
		display: inline-block;
		border-radius: 5px;
		margin-right: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 2px solid #ddd;
		color: #756f6f;
		background: #d8d8d8;
	}
}
.isDistance {
	padding-left: 15px;
}
</style>
